function Hero() {
  return (
    <div
      className="relative bg-cover bg-center h-screen"
      style={{
        backgroundImage: "url('/saving.jpg')",
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-30"></div>

      {/* Centered Content */}
      <div className="relative z-10 flex items-center justify-start h-full pl-10 text-white">
        <div className="max-w-lg">
          <h1 className="text-5xl font-bold mb-16">
            Welcome to{" "}
            <span className="text-yellow-400">Smart Wallet Picks</span>
          </h1>
          <p className="text-lg mb-8">
            Discover the best credit cards tailored to maximize rewards, save
            money, and unlock exclusive benefits. Let us help you build a
            smarter wallet.
          </p>
          <div className="flex space-x-4">
            <a
              href="/aboutus"
              className="px-6 py-3 bg-yellow-400 text-black font-semibold rounded-md shadow-lg hover:bg-yellow-500 transition"
            >
              Read More
            </a>
            <a
              href="/wallet"
              className="px-6 py-3 bg-gray-700 text-white font-semibold rounded-md shadow-lg hover:bg-gray-600 transition"
            >
              Wallet Details
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
